module.exports = __webpack_public_path__ + "static/img/communication_pic@2x.2eac412.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20180102/communication_pic@2x.png
// module id = 246
// module chunks = 1